<template>
  <div class="button-container">
    <button @click="goBack">Back</button>
  </div>
</template>

<script>
import {gameHostConfig} from "@/config";

export default {
  name: "goBack",
  props: ['miniAppModel'],
  methods: {
    goBack() {
      this.handleMiniAppMode(this.miniAppModel.miniAppMode)
    },
    handleMiniAppMode(mode){
      switch (mode){
        case 'portal':{
          this.redirectToUrl(`${gameHostConfig.portalHost}?vodapayUserId=${this.miniAppModel.vodapayUserId}`);
          break;
        }
        case 'fantasy':{
          this.redirectToUrl(`${gameHostConfig.fantasyHost}?fantasyToken=${this.miniAppModel.fantasyToken}`);
          break;
        }
        case 'predictor':{
          this.redirectToUrl(`${gameHostConfig.predictorHost}?fantasyToken=${this.miniAppModel.fantasyToken}`);
          break;
        }
        default:{
          this.redirectBackMiniApp();
          break;
        }
      }
    },
    redirectBackMiniApp(){
      // eslint-disable-next-line no-undef
      my.postMessage()
    },
    redirectToUrl(url){
      window.open(url, '_self');
    }
  },
  mounted() {
    if (this.miniAppModel.miniAppMode === "promoGame") {
      let webViewScript = document.createElement('script')
      webViewScript.setAttribute('src', 'https://appx/web-view.min.js')
      document.head.appendChild(webViewScript)
    }
  }
}
</script>

<style scoped>
button {
  background-color: #EF151C;
  color: #FFFFFF;
  height: 30px;
  border-radius: 8px;
  border: 0;
  font-size: 15px;
}

.button-container {
  display: flex;
  cursor: pointer;
}
</style>